namespace Matrix.Dashboards {
    export interface DataSourceTypeItem {
        Key?: string;
        Name?: string;
        Options?: Serenity.PropertyItem[];
        UseParameters?: boolean;
    }
}
